import { createMass, massToPounds } from 'measure-fns';
import { Heading } from '../../../components/Heading/Heading';
import { Text } from '../../../components/Text/Text';
import { convertWeight } from '@lib/units/convertWeight';

const TOTAL_GOAL_LB = 1_000_000;

interface IProps {
  collectedWeightInKgs: number;
}

export const ProgressSection = ({ collectedWeightInKgs }: IProps) => {
  const collectedLb = massToPounds(createMass(collectedWeightInKgs), { round: true });
  const percent = Math.min(100, Math.round((collectedLb / TOTAL_GOAL_LB) * 100));

  return (
    <section className="flex w-full flex-col gap-3 px-6">
      <div className="bg-lake-fog relative h-2 w-full">
        <div
          className="bg-pike-shade absolute top-0 left-0 h-full"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={collectedLb}
          aria-valuemin={0}
          aria-valuemax={TOTAL_GOAL_LB}
          aria-label="Total trash collected"
        />
      </div>
      <div>
        <Heading variant="lg" as="p" className="text-pike-shade m-0">
          {convertWeight(collectedWeightInKgs, 'lb')}
        </Heading>
        <Text variant="sm" className="text-abyss font-semibold">
          collected toward our {TOTAL_GOAL_LB.toLocaleString('en-US')} lb multi-year goal
        </Text>
      </div>
    </section>
  );
};
